// Revolt Glass Button Component
// Glassmorphic button styling to pair with glass cards

import './RevoltGlassButton.css';

export function RevoltGlassButton({
  children,
  variant = 'default', // 'default' | 'accent' | 'ghost'
  size = 'default', // 'default' | 'sm'
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ...props
}) {
  const buttonClasses = [
    'revolt-glass-btn',
    `revolt-glass-btn-${variant}`,
    `revolt-glass-btn-${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}

